import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { User } from "../domain/user";
import { UserService } from "../service/user.service";
import { Company } from "../domain/company";
import { CompanyService } from "../service/company.service";
import { Router } from "@angular/router";
import { Configuration } from "../domain/configuration";
import * as $ from 'jquery';
import { MessageService } from 'primeng/api';
import { HostListener } from '@angular/core';

@Component({
    templateUrl: "./useredit.component.html",
    host: {
    '(document:keypress)': 'handleKeyboardEvent($event)'
    }
})
export class UserEditComponent implements OnInit {

    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.keyCode == 27)
        {
            this.cancel();
        }
        if (event.keyCode == 13)
        {
            this.saveAndClose();
        }
    }

    pageTitle: string;
    id: string;

    object = new User();

    timeStamp = new Date().getTime();

    companies: Company[];

    urlPicture: string;

    urlPicturePost: string;

    response: any;

    allowUpload: boolean = false;
    imageToUpload: any;

    isDisabled: boolean = false; 

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private companyService: CompanyService,
        private router: Router,
        private messageService: MessageService
    ) {
        this.id = this.route.snapshot.paramMap.get("id");

        if (this.id === "new") {
            this.pageTitle = "New user:";
            this.object = new User();
        } else {
            this.pageTitle = "Edit user:";
            this.userService
                .getById(this.id)
                .then(user => (this.object = user));
        }
    }

    ngOnInit() {
        this.urlPicturePost = Configuration.server + "/api/users/" + this.id;
        this.urlPicture =
            Configuration.server + "/api/users/" + this.id + "/photo";
        var pictureLink = this.getLinkPicture();
        this.GetImage(pictureLink);
    }

    fieldsValid() {

        var valid = true;
        var message;

        if (!this.object.companies) {
            valid = false;
            message = "At least one company must be selected";
        }

        if (this.id === "new")
        {
            if (!this.object.Password || this.object.Password.length < 1) {
                valid = false;
                message = "Password is required";
            }
        }

        if (!this.object.LastName || this.object.LastName.length < 1) {
            valid = false;
            message = "Last name is required";
        }

        if (!this.object.FirstName || this.object.FirstName.length < 1) {
            valid = false;
            message = "First name is required";
        }

        if (!this.object.Name || this.object.Name.length < 1) {
            valid = false;
            message = "Username is required";
        }

        if (!valid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot crate user!',
                detail: message
            });
        }

        return valid;
    }

    saveAndClose() {
        if (this.fieldsValid()) {
            this.isDisabled=true;
            this.userService
                .put(this.object, this.id)
                .then(() => this.router.navigate(["/users"]))
                .then(data=>{
                    this.isDisabled=false;
                })
                .catch(error => {
                    this.isDisabled=false;
                }); 
        }
    }

    save() {
        if (this.fieldsValid()) {
            this.isDisabled=true;
            const result = this.userService
                .put(this.object, this.id) 
                .then(user => this.router.navigate(["/users/" + user.id]))
                .then(data=>{
                    this.isDisabled=false;
                    this.reloadUser();
                })
                .catch(error => {
                    this.isDisabled=false;
                    this.reloadUser();
                }); 
        }
    }

    cancel() {
        this.router.navigate(["/users"]);
    }

    search(event) {
        this.companyService.getAll().then(data => {
            if (this.object.companies) {
                this.object.companies.forEach((company) => {
                    data.splice(data.findIndex(c => c.id === company.id), 1);
                });
            }

            this.companies = data.filter(c => c.name.toLowerCase().includes(event.query.toLowerCase()));
        });
    }

    reloadUser(){
        if (this.id === "new") {
            this.pageTitle = "New user:";
            this.object = new User();
        } else {
            this.pageTitle = "Edit user:";
            this.userService
                .getById(this.id)
                .then(user => (this.object = user));
        }
        this.ngOnInit();
    }

    public GetImage(url)
    {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = "blob";
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.onload = this.loadImage;
        http.send();
    } 

    public loadImage(e) {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        $("#photoToUpload").attr('src', imageUrl);
    }

    public ImageExists(url)
    {
        var http = new XMLHttpRequest();
        http.open('GET', url, false);
        let token = localStorage.getItem('jwt');
        http.setRequestHeader('Authorization', 'Bearer ' + token);
        http.send();
        return http.status!=404;
    }

    public getLinkPicture() {
        if (this.id !== 'new') {
            if (this.timeStamp) {
                if (this.ImageExists(this.urlPicture + "?" + this.timeStamp)) {
                    return this.urlPicture + "?" + this.timeStamp;
                } else {
                    return "../assets/layout/images/user-image-placeholder.png";
                }
            }
            return this.urlPicture;
        } else {
            return "../assets/layout/images/user-image-placeholder.png";
        }
    }

    public setLinkPicture(url: string) {
        this.urlPicture = url;
        this.timeStamp = new Date().getTime();
    }

    onUpload(event) {
        if (this.allowUpload) {
            this.setLinkPicture(this.urlPicture);
            this.messageService.add({
                severity: 'success',
                summary: 'Image successfully uploaded!'
            });
        }
    }

    onPictureSelect(event) {
        this.allowUpload = false;
        this.imageToUpload = undefined;

        if (event.files[0]) {
            this.imageToUpload = event.files[0];
            //check if file is larger than 0,5MB
            if (event.files[0].size / 1000000 > 0.5) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Can not upload image',
                    detail: 'Image is larger than allowed (0,5 MB)! Please choose another image.'
                });
                return;
            }
            console.log(this.imageToUpload);
            //check if image is square
            var img = new Image();
            img.onload = () => {
                if (img.width !== img.height) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Can not upload image',
                        detail: 'Only square images can be uploaded as profile photos! For example (in pixels): 200x200, 400x400 etc.'
                    });
                    return;
                } else {
                    this.setImageToUploadPhoto(this.imageToUpload);
                }
            }
            img.src = window.URL.createObjectURL(this.imageToUpload);
        }
    }

    setImageToUploadPhoto(src) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('#photoToUpload').hide();
            $('#uploadedPhotoWrapper').html('<img id="photoToUpload" />');
            $('#photoToUpload')
                .attr('src', reader.result as string)
                .height(100)
                .width("auto");
        };

        reader.readAsDataURL(src);

        this.allowUpload = true;
    }
}
